/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var PRIORITY;
(function (PRIORITY) {
    PRIORITY[PRIORITY["_1"] = 1] = "_1";
    PRIORITY[PRIORITY["_2"] = 2] = "_2";
    PRIORITY[PRIORITY["_3"] = 3] = "_3";
})(PRIORITY || (PRIORITY = {}));
